import script from "./SpaceUpdateCom.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceUpdateCom.vue?vue&type=script&setup=true&lang=js"

import "./SpaceUpdateCom.vue?vue&type=style&index=0&id=b10c6080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b10c6080"]])

export default __exports__